export default __webpack_public_path__ + "static/media/ksivalue_mobile_small.a05ea073.jpg";